import React from "react";

class PercentageInput extends React.Component {
  constructor(props) {
    super(props);

    this.textInputRef = React.createRef();

    this.state = {
      value:
        this.props.value || this.props.value === 0
          ? this.props.value * 100
          : null,
    };
  }

  componentDidMount() {
    this.bindAutoNumeric();

    if (document.getElementsByTagName) {
      var inputElements = document.getElementsByTagName("input");
      for (var i = 0; inputElements[i]; i++) {
        if (!inputElements[i].autocomplete) {
          inputElements[i].setAttribute("autocomplete", "off");
        }
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    var self = this;

    if (
      this.state.value !== nextProps.value &&
      typeof nextProps.value != "undefined"
    ) {
      if (nextProps.value === null || nextProps.value === "") {
        this.setState({ value: "" }, function () {
          $(self.textInputRef.current).autoNumeric("wipe");
        });
      } else {
        this.setState({ value: nextProps.value }, function () {
          $(self.textInputRef.current).autoNumeric(
            "set",
            self.state.value * 100
          );
        });
      }
    }

    if (document.getElementsByTagName) {
      var inputElements = document.getElementsByTagName("input");
      for (var i = 0; inputElements[i]; i++) {
        if (!inputElements[i].autocomplete) {
          inputElements[i].setAttribute("autocomplete", "off");
        }
      }
    }
  }

  bindAutoNumeric() {
    var self = this;

    $(this.textInputRef.current)
      .val(this.state.value)
      .autoNumeric({
        aSep: $("#delimiter").val() || ",",
        aDec: $("#separator").val() || ".",
        mDec: this.props.mDec || null,
        vMin: this.props.min || "-999.99",
        vMax: this.props.max || "999.99",
        lZero: "keep",
        aForm: false,
      })
      .on("change", function () {
        self.onInput();
      })
      .on("input", function () {
        self.onInput();
      });
  }

  onInput() {
    var value = "";
    var percentage = $(this.textInputRef.current).autoNumeric("get") / 100;

    if (!isNaN(percentage)) {
      value = percentage;
    }

    this.setState({ value: value }, () => {
      if (this.props.onChange) {
        // call original callback, if it exists
        if (this.props.onChangeEventType === true) {
          this.props.onChange({
            target: { value: value, name: this.props.name },
          });
        } else {
          this.props.onChange(value);
        }
      }
    });
  }

  render() {
    return (
      <div className="input-group PercentageInput">
        <input
          type="text"
          ref={this.textInputRef}
          disabled={this.props.disabled}
          name={this.props.name + "_masked"}
          className={this.props.className + " percentageInput form-control"}
          tabIndex={this.props.tabIndex || 0}
          style={{
            textAlign: "right",
            backgroundColor: "white",
            cursor: "default",
          }}
        />
        <div className="input-group-append">
          <span className="input-group-text">%</span>
        </div>
      </div>
    );
  }

  getValue() {
    return this.state.value;
  }
}

export default PercentageInput;
